(function ($) {

    if ($('nav').length > 0) {
        // add class
    } else {
        $('header').addClass('global-header--without-nav');
    }

})(window.jQuery);